import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from './Tooltip';

/** Заголовок с иконкой-подсказкой
 * props:
 *  title - текст заголовка
 *  hint - текст подсказки, без него рендерится только заголовок
 *  trigger - 'click' (по умолчанию) или 'hover'
 **/
const TitleWithHint = ({ title, hint, trigger = 'click', className, iconClassName }) => {
  if (!hint) return title;

  return (
    <span className={`inline-flex items-center gap-1 ${className ?? ''}`}>
      {title}
      <Tooltip text={hint} trigger={trigger}>
        <InfoOutlinedIcon fontSize="small" className={iconClassName ?? 'text-gray-400 hover:text-orange-500 transition-colors'} />
      </Tooltip>
    </span>
  );
};

export default TitleWithHint;
